import { Routes, Route } from 'react-router-dom';

// Pages
import AuthPage from './pages/AuthPage/AuthPage';
import { PasswordResetPage } from './pages/PasswordResetPage/PasswordResetPage';
import NewUserLoginPage from './pages/NewUserLoginPage/NewUserLoginPage';

// Components
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import { MainLayout } from './components/MainLayout/MainLayout';

// Protected Pages
import DashboardPage from './pages/DashboardPage/DashboardPage';
import AppointmentPage from './pages/AppointmentPage/AppointmentPage';
import ResourcePage from './pages/ResourcePage/ResourcePage';
import { GuestContactPage } from './pages/ContactPage/GuestContactPage';
import { AuthenticatedContactPage } from './pages/ContactPage/AuthenticatedContactPage';
import { Profile } from './pages/ProfilePage/Profile';
import { RegistrationCarousel } from './components/RegistrationCarousel/RegistrationCarousel';
import { RegistrationPage } from './pages/RegistrationPage/RegistrationPage';
import { AuthProvider } from './contexts/AuthContext';
import { DocumentTitle } from './components/DocumentTitle/DocumentTitle';
import EventsPage from './pages/EventsPage/EventsPage';

function App() {
  return (
    <AuthProvider>
      <DocumentTitle />
      <Routes>
        <Route path="/" element={<AuthPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/reset-password" element={<PasswordResetPage />} />
        <Route path="/carousel-presentation" element={<RegistrationCarousel />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/new-user-login" element={<NewUserLoginPage />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <MainLayout>
                <EventsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/appointment"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AppointmentPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/resources"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ResourcePage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/guest-contact"
          element={
            <MainLayout showHeader={false}>
              <GuestContactPage />
            </MainLayout>
          }
        />
        <Route
          path="/contact"
          element={
            <ProtectedRoute>
              <MainLayout>
                <AuthenticatedContactPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Profile />
              </MainLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
